import longTaskFactory from '@atlassian/jira-software-roadmap-utils/src/utils/metrics/long-task.tsx';
import { ROADMAP_APP_ID } from '../../../../constants.tsx';

export default longTaskFactory(ROADMAP_APP_ID);
